// Must be first: installs the global 401 handler before any component makes a
// request, so an invalid/stale session fails safe to /login instead of a blank
// crashed page (AISC issues#4).
import "./utils/sessionGuard";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./assets/scss/style.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
